import React from "react";
import { COLORS } from "../data/profile";
import { useLang } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";
import ChatTab from "./ChatTab";

export default function AIChatSection() {
  const { lang } = useLang();

  return (
    <section id="ai-chat" className="chat-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading">
            {lang === "en"
              ? "Curious? Ask my AI anything about my experience"
              : "Curieux ? Demandez à mon IA n'importe quoi sur mon parcours"}
          </h2>
          <p className="section-sub">
            {lang === "en"
              ? "Trained on my actual work. Honest, including about what I don't know."
              : "Entraîné sur mon travail réel. Honnête, y compris sur ce que je ne sais pas."}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <ChatTab />
        </ScrollReveal>
      </div>
    </section>
  );
}
